module.exports = __webpack_public_path__ + "media/images/flags/1x1/and-4b8663003c7877391198cbb468636a08.svg";